<div class="d-flex flex-column align-items-center w-100">
  <div class="photo-circle position-relative d-flex align-items-center justify-content-center"
    [class.disabled]="disabled()"
    (click)="triggerFileInput()"
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)">

    @if (previewUrl()) {
      <img [src]="previewUrl()"
        alt="Photo preview"
        class="photo-preview">
      <div
        class="photo-overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center">
        <button type="button"
          mat-icon-button
          class="remove-button"
          [disabled]="disabled()"
          (click)="removePhoto(); $event.stopPropagation()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    } @else {
      <div class="p-5 d-flex flex-column align-items-center justify-content-center text-center">
        <mat-icon class="upload-icon">add_a_photo</mat-icon>
      </div>
    }
  </div>

  <input type="file"
    id="photo-file-input"
    class="d-none"
    [accept]="acceptedFormats()"
    [disabled]="disabled()"
    (change)="onFileSelected($event)">

  @if (fileName()) {
    <p class="text-truncate mat-body-small text-center text-muted mb-0">{{ fileName() }}</p>
  }

  @if (errorMessage()) {
    <p class="text-truncate mat-body-small text-center text-danger mb-0">{{ errorMessage() }}</p>
  }
</div>